module.exports = __webpack_public_path__ + "img/gemischtertellermithintergrund.5a1012b8.jpg";